export function coordToLatLng (markerCoords) {
    if (!markerCoords || !window.google.maps) {
        console.warn("Invalid coordinates or Maps API not loaded");
        return null;
    }

    return new window.google.maps.LatLng(
        typeof markerCoords.lat === 'function' ? markerCoords.lat() : markerCoords.lat, 
        typeof markerCoords.lng === 'function' ? markerCoords.lng() : markerCoords.lng
    );
}